import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CreateMealAction } from '../../../../../store/create-meal-slice';
import { splitMeatTypeValue } from '../../../../../utils/foodUtils';

const meatTypesList = [
  'NotApplicable',
  'Fish',
  'Pork',
  'Beef',
  'Mutton',
  'Venison',
  'Poultry',
];

const ProvideMeatTypeComponent = () => {
  const dispatch = useDispatch();
  const { meatType } = useSelector((state) => state.createMeal);
  const selectedMeatTypes = splitMeatTypeValue(meatType);

  const updateSelectedMeatTypes = (nextSelectedMeatTypes) => {
    const nextMeatType =
      nextSelectedMeatTypes.length > 0
        ? nextSelectedMeatTypes.join(',')
        : 'NotApplicable';

    dispatch(CreateMealAction.updateMeatType(nextMeatType));
  };

  const handleMeatTypeChange = (selectedValue, isChecked) => {
    if (selectedValue === 'NotApplicable') {
      updateSelectedMeatTypes(isChecked ? ['NotApplicable'] : []);
      return;
    }

    if (isChecked) {
      updateSelectedMeatTypes([
        ...selectedMeatTypes.filter((value) => value !== 'NotApplicable'),
        selectedValue,
      ]);
      return;
    }

    updateSelectedMeatTypes(
      selectedMeatTypes.filter((value) => value !== selectedValue)
    );
  };

  return (
    <Grid2 container columnSpacing={1}>
      <Grid2 xs={2}>
        <Typography variant='s16_w600' component='span'>
          Provide a Meat Type:*
        </Typography>
      </Grid2>
      <Grid2 xs={8}>
        <FormControl>
          <FormGroup row>
            {meatTypesList.map((item) => (
              <FormControlLabel
                key={item}
                sx={{
                  width: {
                    xs: '45%',
                    md: '30%',
                  },
                }}
                control={
                  <Checkbox
                    checked={selectedMeatTypes.includes(item)}
                    onChange={(event) => {
                      handleMeatTypeChange(item, event.target.checked);
                    }}
                  />
                }
                label={item === 'Mutton' ? 'Lamb' : item}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid2>
    </Grid2>
  );
};

export default ProvideMeatTypeComponent;
